import type { FC } from "react";
import type { Address } from "viem";

import type { CreditAccountOperation, TokensList } from "../model";
import type { ProtocolsList } from "../protocols";
import { HistoryBody } from "./body";

export interface CreditAccountHistoryProps {
  underlyingToken: Address;
  tokens: TokensList;
  protocols: ProtocolsList;
  dataList: CreditAccountOperation[];
  chainId: number;
}

export const CreditAccountHistory: FC<CreditAccountHistoryProps> = props => {
  return (
    <div
      className="grid w-full text-gray-200"
      style={{
        gridTemplateColumns: "minmax(160px, 1fr) minmax(120px, 1fr) 2fr",
      }}
    >
      <div className="col-span-3 grid grid-cols-subgrid pb-2 border-b border-gray-700 text-xs uppercase text-gray-400">
        <div>Protocol</div>
        <div>Operation</div>
        <div>Details</div>
      </div>
      <HistoryBody {...props} />
    </div>
  );
};
